import { AgreementContainer, AgreementPaper, AgreementContent, AgreementScrollToTop } from "../AgreementLayout";
import { remoteHealthServiceTermsInfoHtml } from "../../../constants/agreements/remoteHealthInformationTexts";

const RemoteHealthServiceTermsInfo = () => {
    return (
        <AgreementContainer sx={{ py: 4 }}>
            <AgreementScrollToTop />
            <AgreementPaper elevation={0} sx={{ border: "1px solid", borderColor: "divider" }}>
                <AgreementContent dangerouslySetInnerHTML={{ __html: remoteHealthServiceTermsInfoHtml }} />
            </AgreementPaper>
        </AgreementContainer>
    );
};

export default RemoteHealthServiceTermsInfo;
